import { useAuth } from '@hourly/contexts/AuthContext';
import { Button, ButtonSize, ButtonVariant } from '@hourly-hds/components';
import StepLayout from '../_shared/StepLayout';
import AnimatedLoader from '../components/AnimatedLoader';
import Document from './components/Document';
import DocumentView from './components/DocumentView';
import { useSignDocuments } from './data/useSignDocuments';
import styles from './SignDocuments.module.css';

interface SignDocumentsProps {
  isCompleted: boolean;
  onContinue: () => void;
  onPrevious: () => void;
}

const SignDocuments = ({ isCompleted, onContinue, onPrevious }: SignDocumentsProps) => {
  const { sessionState } = useAuth();
  const {
    documentUrl,
    isSignDocumentsLoading,
    isRequestingDocumentUrl,
    getDocumentsLink,
    signDocuments,
    cleanDocumentUrl,
  } = useSignDocuments();

  const handleAttemptGetDocumentLink = async () => {
    await getDocumentsLink({
      partnerId: sessionState.partnerId!,
      partnerUserId: sessionState.userId!,
    });
  };

  if (isRequestingDocumentUrl) {
    return <AnimatedLoader>We are generating your document for signature...</AnimatedLoader>;
  }

  return (
    <StepLayout>
      <StepLayout.Header>
        <StepLayout.Title>Review and Sign your Onboarding Documents</StepLayout.Title>
      </StepLayout.Header>

      <StepLayout.Content>
        <div className={styles.documents}>
          <Document isCompleted={isCompleted}>Partner Referral Agreement</Document>
          <Document isCompleted={isCompleted}>W-9</Document>
        </div>
      </StepLayout.Content>

      <StepLayout.Actions>
        <Button
          fullWidth
          label="Previous"
          onClick={onPrevious}
          size={ButtonSize.Large}
          disabled={isSignDocumentsLoading}
        />
        <Button
          fullWidth
          label="Continue"
          size={ButtonSize.Large}
          variant={ButtonVariant.Primary}
          disabled={isSignDocumentsLoading}
          onClick={isCompleted ? onContinue : handleAttemptGetDocumentLink}
        />
      </StepLayout.Actions>
      <DocumentView
        open={!!documentUrl}
        url={documentUrl}
        onClose={cleanDocumentUrl}
        onFinish={(signStatus) => {
          if (signStatus === 'Completed') {
            signDocuments(sessionState.partnerId!).then(onContinue);
          }
        }}
      />
    </StepLayout>
  );
};

export default SignDocuments;
